module.exports = __webpack_public_path__ + "img/el-kios-01.f185c685.jpg";